<h3>{{ title }}</h3>

<div class="col-md-12">
  <mat-form-field class="col-12">
    <mat-label>Table Columns</mat-label>
    <mat-select #columnSelect multiple>
      @if (tableColumns) {
        <mat-option>
          <ngx-mat-select-search (ngModelChange)="onSearch($event)" [clearSearchInput]="false"
            [formControl]="roleFilterCtrl"
            noEntriesFoundLabel="No matching Column found"
            placeholderLabel="Select Column...">
          </ngx-mat-select-search>
        </mat-option>
        @for (data of tableColumns; track data) {
          <mat-option [value]="data">  {{ data.title }}</mat-option>
        }
      }
    </mat-select>
  </mat-form-field>
</div>

<div mat-dialog-actions class="d-flex justify-content-end">
  <button mat-button mat-dialog-close>Close</button>
  <button mat-button [mat-dialog-close]="columnSelect.value">Display</button>
</div>
